import React from "react";
import Select from "react-select";
import DropDownStyles from "../../../pages/staff/dropdownStyles.js";

const PageSizeDropDownSelection = ({ defaultValue, onChange }) => {
  const pageSizeOptions = [
    { value: "20", label: "20" },
    { value: "50", label: "50" },
    { value: "100", label: "100" },
  ];

  return (
    <Select
      defaultValue={defaultValue}
      onChange={onChange}
      options={pageSizeOptions}
      styles={DropDownStyles}
      placeholder={"Page Size"}
    />
  );
};

export default PageSizeDropDownSelection;

export const SortOrderDropDownSelection = ({ defaultValue, onChange, styles, ...otherProps }) => {
  const sortOrderOptions = [
    { value: "DESC", label: "Desc" },
    { value: "ASC", label: "Asc" },
  ];

  return (
    <Select
      defaultValue={defaultValue}
      onChange={onChange}
      options={sortOrderOptions}
      styles={styles || DropDownStyles}
      placeholder={"Sort Order"}
      {...otherProps}
    />
  );
};

export const GenderDropDownSelection = ({
  defaultValue,
  onChange,
  selectedValue,
}) => {
  const genderOptions = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
    { value: "Other", label: "Other" },
  ];

  return (
    <Select
      defaultValue={defaultValue}
      value={genderOptions.find((option) => option.value === selectedValue)}
      onChange={onChange}
      options={genderOptions}
      styles={DropDownStyles}
      placeholder="Select Gender"
      isClearable={true}
    />
  );
};
